'use client';

import { useMemo } from 'react';
import { useGetDiscoveryMapQuery } from 'src/api/redux';
import { useDiscoveryMapQueryParams } from '../../ResultsPanel/hooks/useDiscoveryQueryParams';

const useGetClusterObjects = (activeMarker) => {
  const { queryParams, skip } = useDiscoveryMapQueryParams();
  const { data: discoveryResults } = useGetDiscoveryMapQuery(queryParams, {
    skip,
  });

  const clusterObjects = useMemo(() => {
    return discoveryResults?.results?.map((point) => {
      return {
        details: point,
        properties: {
          cluster: false,
          id: point.id,
          count: point.count,
          claims: point.claims, // for heatmap
          provider_id: point.provider_id,
          hovered: activeMarker
            ? activeMarker === point.id || activeMarker === point.provider_id
            : false,
        },
        geometry: {
          type: 'Point',
          coordinates: [point.lng, point.lat],
        },
      };
    });
  }, [activeMarker, discoveryResults?.results]);

  return {
    clusterObjects,
  };
};

export default useGetClusterObjects;
